// Shared analytics UI components.
// theme.js holds values/style only (no JSX); shared analytics *components* live here.
import { CL, FONT } from './theme.js';

const panelTitleStyle = {
  display: 'flex', alignItems: 'center', gap: 8, margin: 0, marginBottom: 10,
  fontSize: 10, fontWeight: 700, color: CL.stone, letterSpacing: 1.6,
  textTransform: 'uppercase', fontFamily: FONT.body,
};

// ◆ gold-diamond uppercase section header used across the analytics screens.
export function PanelTitle({ children }) {
  return (
    <h3 style={panelTitleStyle}>
      <span style={{ display: 'inline-block', width: 5, height: 5, background: CL.gold, transform: 'rotate(45deg)', flexShrink: 0 }} />
      <span>{children}</span>
    </h3>
  );
}
